import script from "./AdminPaymentResultView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPaymentResultView.vue?vue&type=script&setup=true&lang=js"

import "./AdminPaymentResultView.vue?vue&type=style&index=0&id=356bcadd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356bcadd"]])

export default __exports__